module.exports = __webpack_public_path__ + "img/1886795.0d02923b.png";